import * as pbm from '@/grpc-gen/message_center_service_pb';
import Reservation from '@/model/Reservation';
import { MessageRuleMapping } from '@/model/MessageRule';
import Campaign from './campaign';
import EventType from './event-type';
import Handlebar from './handlebar';
import MessageRule from './message-rule';
import MessageSettings from './message-settings';
import MessageTranslation from './message-translation';
import MessageType from './message-type';
import ReservationService from './reservation-service';
import Tab from './tab';

export interface MessageCenterMapping extends MessageRuleMapping {

}

export default class MessageCenter {
  settings: MessageSettings = new MessageSettings();

  translations: MessageTranslation[] = [];

  messageTypes: MessageType[] = [];

  eventTypes: EventType[] = [];

  campaigns: Campaign[] = [];

  services: ReservationService[] = [];

  tabs: Tab[] = [];

  handlebars: Handlebar[] = [];

  rules: MessageRule[] = [];

  static fromGrpcResponse(r: pbm.MessageCenterResponse, m: MessageCenterMapping): MessageCenter {
    const preferences = new MessageCenter();

    const { settings } = r;
    const translations = r.translations ?? [];
    const messageTypes = r.messageTypes ?? [];
    const eventTypes = r.eventTypes ?? [];
    const campaigns = r.campaigns ?? [];
    const services = r.services ?? [];
    const tabs = r.tabs ?? [];
    const handlebars = r.handlebars ?? [];

    preferences.settings = MessageSettings.fromGrpcModel(settings);
    preferences.translations = translations.map((t) => MessageTranslation.fromGrpcModel(t));
    preferences.messageTypes = messageTypes.map((mt) => MessageType.fromGrpcModel(mt));
    preferences.eventTypes = eventTypes.map((e) => EventType.fromGrpcModel(e));
    preferences.campaigns = campaigns.map((c) => Campaign.fromGrpcModel(c));
    preferences.services = services.map((s) => ReservationService.fromGrpcModel(s));
    preferences.tabs = tabs.map((t) => Tab.fromGrpcModel(t));
    preferences.handlebars = handlebars.map((h) => Handlebar.fromGrpcModel(h));

    return preferences;
  }
}
